var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dataListingToShow),function(el){return _c('ElementContainer',_vm._b({key:el,attrs:{"element":el}},'ElementContainer',_vm.$attrs,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }